import Vue from 'vue'
import AView from '@/views/AView'

import 'normalize.css'
import 'animate.css'
import '@/styles/index.scss'

Vue.config.productionTip = false

new Vue({
  render: h => h(AView)
}).$mount('#app')
